import React from "react";
import PropTypes from "prop-types";
import SvgComponent from "./errorSvg";
import { Heading, VStack, Text, Box } from "@chakra-ui/react";

const ErrorMsg = ({ title, message, children, ...rest }) => {
  return (
    <VStack
      spacing={4}
      direction="column"
      flexGrow={1}
      justifyContent="center"
      alignItems="center"
      {...rest}
    >
      <Box
        color="brand.primary.400"
        background="#fff"
        borderRadius="999px"
        border="3px solid"
        borderColor="brand.primary.400"
        p={1}
      >
        <SvgComponent height={80} />
      </Box>
      <Heading>{title}</Heading>
      <Text>{message}</Text>
      {children}
    </VStack>
  );
};

ErrorMsg.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  variant: PropTypes.string,
  children: PropTypes.node,
};

export default ErrorMsg;
